<template>
    <div class="kiosk-check-in-card m-auto">
        <slot></slot>
    </div>
</template>
<script>
export default {
}
</script>
